import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-field',
  standalone: true,
  template: `<ng-content></ng-content>
    @if (error) {
      <div class="ui-field-error">{{ error }}</div>
    }`,
  styleUrl: './ui-field.component.scss',
})
export class UiFieldComponent {
  @Input() error?: string | null;
}
